export default function() {
  return {
    product_id: null,
    vendor_id: null,
    project_date: null,
    vendor_partno: null,
    hs_partno: null,
    vendor_specsheet: null,
    price_date: null,
    currency: null,
    unit_price: null,
    quantity: null,
    terms: null,
    remarks: null,
    product_data: [],
    product_data2: []
  }
}